module.exports = __webpack_public_path__ + "img/icon_heart_rate_active.1c56439f.svg";